module.exports = ".machine-reports-select {\n  padding: 8px 20px 20px 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/machine-reports/machine-reports.scss
// module id = ./src/app/components/machine-reports/machine-reports.scss
// module chunks = main